// extracted by mini-css-extract-plugin
export var pageTitleWrapper = "preflight-module--page-title-wrapper--5P+ih";